import React from 'react';

const RenderPixels=(props)=>{
  return props.pixels.map((item,index)=>{
    return (
      <div key={index}>
        {item}
      </div>
    );
  })
}
export default RenderPixels;



// WEBPACK FOOTER //
// ./src/Components/RenderPixels.js